import * as React from 'react'
import { ReactElement } from 'react'
import ReportForm from './ReportForm'
import { DocumentGenerationType } from '../../../../hooks/document/documentGenerationTypes'
import { ReportFormType } from '../../../../pages/Finance/Reports'

export default function TierReportForm(props: ReportFormType): ReactElement {
    return <ReportForm title="Tarieven per dossier" generationType={DocumentGenerationType.RatesPerFile} {...props} />
}
